export default function Datenschutz() {
  return (
    <main id="main-content" className="pt-32 pb-20" data-testid="datenschutz-page">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold text-[#1A52D8] mb-8">
            Datenschutzerklärung
          </h1>

          <div className="prose prose-lg max-w-none text-[#475569] space-y-8">
            <section>
              <h2 className="text-xl font-bold text-[#1A52D8] mb-4">
                1. Datenschutz auf einen Blick
              </h2>
              <h3 className="text-lg font-semibold text-[#1A52D8] mb-2">
                Allgemeine Hinweise
              </h3>
              <p>
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
                personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene 
                Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1A52D8] mb-4">
                2. Verantwortliche Stelle
              </h2>
              <p>
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
              </p>
              <p className="mt-4">
                Phönix Pflegeteam Itzehoe<br />
                Lindenbusch 13a<br />
                25578 Dägeling<br />
                Telefon: 0151 46173685<br />
                E-Mail: info@pflegeteam-itzehoe.de
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1A52D8] mb-4">
                3. Datenerfassung auf dieser Website
              </h2>
              <h3 className="text-lg font-semibold text-[#1A52D8] mb-2">Kontaktformular</h3>
              <p>
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben 
                aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten 
                zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns 
                gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1A52D8] mb-4">
                4. Ihre Rechte
              </h2>
              <p>Sie haben jederzeit das Recht:</p>
              <ul className="list-disc list-inside mt-2 space-y-2">
                <li>Auskunft über Ihre bei uns gespeicherten Daten zu erhalten</li>
                <li>Die Berichtigung unrichtiger Daten zu verlangen</li>
                <li>Die Löschung Ihrer Daten zu verlangen</li>
                <li>Die Einschränkung der Verarbeitung zu verlangen</li>
                <li>Der Verarbeitung zu widersprechen</li>
                <li>Die Datenübertragbarkeit zu verlangen</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1A52D8] mb-4">
                5. Google Maps
              </h2>
              <p>
                Diese Seite nutzt über eine API den Kartendienst Google Maps. Anbieter ist die 
                Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.
              </p>
              <p className="mt-4">
                Zur Nutzung der Funktionen von Google Maps ist es notwendig, Ihre IP-Adresse zu 
                speichern. Diese Informationen werden in der Regel an einen Server von Google in 
                den USA übertragen und dort gespeichert.
              </p>
            </section>

            <section className="legal-notice">
              <p>
                <strong>Stand:</strong> Dezember 2025
              </p>
            </section>
          </div>
        </div>
      </div>
    </main>
  );
}
